import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { IconNext } from '../../../components/app/icons/next';
import { WebButton as Button } from '../../../components/web/button/web-button';
import { useRootStore } from '../../../providers/root-store-provider';
import { routes } from '../../../config/routes';
import { BillingPeriod, getPremiumLookupKeyByBillingPeriod } from '../../../models/functions/billing-period';

type WebPricingActionProps = {
    period: BillingPeriod;
};

export const WebPricingAction: React.FC<WebPricingActionProps> = observer(({ period }) => {
    const { t } = useTranslation();
    const rootStore = useRootStore();
    const { authStore } = rootStore;
    const { stripeStore } = rootStore;
    const [isLocalLoading, setIsLocalLoading] = useState<boolean>(false);
    const isLoading = (authStore.loading || stripeStore.loading) && isLocalLoading;

    const loggedUser = rootStore.cookieService.hasJwtToken();

    const lookupKey = getPremiumLookupKeyByBillingPeriod(period);

    if (loggedUser) {
        // Logged user with active premium tariff
        if (authStore.userHasPremiumTariff) {
            return (
                <div className="flex flex-col gap-[1.2rem]">
                    <p className="text-center text-web-copy">{t('blocks.pricing.premium.action.isActive')}</p>
                    <Button
                        nativeLink
                        href={routes.app.index}
                        variant="primary"
                        size={{ xs: 'medium', sm: 'vlarge' }}
                        block
                        icon={<IconNext />}
                        iconGap="xsmall"
                    >
                        {t('pages.layout.header.goToApp')}
                    </Button>
                </div>
            );
        }

        return (
            <Button
                onClick={async () => {
                    setIsLocalLoading(true);
                    await stripeStore.createCheckoutSession(lookupKey);
                    await authStore.fetchUserProfile();
                }}
                loading={isLoading}
                variant="primary"
                size={{ xs: 'medium', sm: 'vlarge' }}
                block
                icon={<IconNext />}
                iconGap="xsmall"
            >
                {t('blocks.pricing.premium.action.getPremium')}
            </Button>
        );
    }

    // Not logged user => Sign up button (= open modal)
    return (
        <Button
            onClick={() => {
                setIsLocalLoading(true);
                authStore.authDialogStore.setSignupActive(lookupKey);
            }}
            variant="primary"
            size={{ xs: 'medium', sm: 'vlarge' }}
            block
            icon={<IconNext />}
            iconGap="xsmall"
        >
            {t('blocks.pricing.premium.action.signUp')}
        </Button>
    );
});
